import WorkExperience from '@/models-ts/user/WorkExperience'

const comparedFields = ['organization', 'description', 'position', 'from', 'to']

// @ts-ignore
export default (exp: WorkExperience) => comparedFields.some((field) => exp[field])
